export enum WidgetsActionTypes {
	SUBSCRIBE_WIDGET = 'SUBSCRIBE_WIDGET',
	UNSUBSCRIBE_WIDGET = 'UNSUBSCRIBE_WIDGET',
	UPDATE_LOCATION = 'UPDATE_LOCATION',
	UPDATE_ORDER = 'UPDATE_ORDER',
	SET_SETTINGS_OPEN = 'SET_SETTINGS_OPEN',
	SET_ACTIVE_WIDGET = 'SET_ACTIVE_WIDGET',
	SET_MINIMIZED_WIDGET = 'SET_MINIMIZED_WIDGET',
	SET_WINDOW_SIZE = 'SET_WINDOW_SIZE',
	SET_WIDGET_SIZE = 'SET_WIDGET_SIZE'
}